import { defineEntity, custom } from './_helpers.js';

export default defineEntity(
    'integrationConnection',
    {
        connectionTested: custom({ scope: 'integration' }),
        credentialRotated: custom({ scope: 'integration' }),
        endpointInvoked: custom({ scope: 'integration' }),
        mappingPublished: custom({ scope: 'integration' }),
        importStarted: custom({ scope: 'integration' }),
        importCompleted: custom({ scope: 'integration' }),
        importFailed: custom({ scope: 'integration' }),
        syncStarted: custom({ scope: 'integration' }),
        syncCompleted: custom({ scope: 'integration' }),
        syncFailed: custom({ scope: 'integration' }),
        conflictDetected: custom({ scope: 'integration' }),
        conflictResolved: custom({ scope: 'integration' }),
        webhookReceived: custom({ scope: 'integration' }),
        actionExecuted: custom({ scope: 'integration' }),
        upgradeRequired: custom({ scope: 'integration' }),
        upgradeCompleted: custom({ scope: 'integration' }),
    },
    { includeDefaultLifecycle: true },
);
